var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',_vm._b({staticClass:"mb-2 overflow-hidden",class:{ 'on-hover': hover },attrs:{"tile":"","flat":"","elevation":hover ? 16 : 2}},'v-card',_vm.$attrs,false),[_c('a',{attrs:{"href":_vm.data.url,"target":"_blank"}},[_c('v-img',{attrs:{"alt":"Imagine","src":_vm.data.image}})],1)])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }